export const IMAGE_ROOT = 'https://image.tmdb.org/t/p/w500'
export const API_ROOT = 'https://api.themoviedb.org/3'
